export default __webpack_public_path__ + "static/media/lessee 1.cde56a03.png";